/**
* Returns formatted 'price' string for UI
*
* @param {object} course object
*/

import hourlyPrice from './hourlyPrice';

export default ({price_cents, session_length_minutes, session_count, catalog_type, id}) => {
  if (Array.isArray(price_cents)) {
    const uniquePrices = Array.from(new Set(price_cents));
    // If the array only contains a single price, else throw warning
    if (uniquePrices.length === 1) {
      price_cents = uniquePrices[0];
    } else {
      console.warn(`Price array for ${catalog_type} (${id}) has multiple values: ${price_cents}`);
      price_cents = undefined;
    }
  }

  const priceInCents = parseInt(price_cents);
  const hoursPerSession = parseInt(session_length_minutes) / 60;
  const sessionCount = parseInt(session_count);
  if (priceInCents === 0) {
    return 'Free';
  } else if (priceInCents >= 100 && hoursPerSession > 0 && sessionCount > 0) {
    return '$' + hourlyPrice(priceInCents, hoursPerSession, sessionCount) + '/hr';
  } else if (catalog_type === 'catalog-topics-v1') {
    return 'See Prices';
  } else {
    return 'Call for Info';
  }
};
